import { ComponentProps } from 'react';

import { EmployerBanner } from '@foradevelopment/fora-ui';

import { ResponsiveNavBar } from '../ResponsiveNavbar';

type SmallHeaderProps = ComponentProps<typeof EmployerBanner> & { hasSelectedEmployer: boolean };

export const SmallHeader = ({ hasSelectedEmployer, ...props }: SmallHeaderProps) => {
  return (
    <>
      <ResponsiveNavBar hasSelectedEmployer={hasSelectedEmployer} />
      <EmployerBanner {...props} />
    </>
  );
};
